import { render, staticRenderFns } from "./DefinitionGroup.vue?vue&type=template&id=161e9bfe"
import script from "./DefinitionGroup.vue?vue&type=script&lang=js"
export * from "./DefinitionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports